import { useState } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@material-ui/core';

ExpandableList.propTypes = {
  items: PropTypes.array.isRequired,
  max: PropTypes.number,
  getKey: PropTypes.func.isRequired
};

ExpandableList.defaultProps = {
  max: 3
};

export default function ExpandableList({ items, max, getKey }) {
  const [showAll, setShowAll] = useState(false);

  if (!items || items.length === 0) {
    return null;
  }

  const hasMore = items.length > max;
  const visibleItems = hasMore && !showAll ? items.slice(0, max) : items;
  return (
    <>
      <ul style={{ margin: '4px 0 0', paddingInlineStart: '20px' }}>
        {visibleItems.map((item) => (
          <li key={getKey(item)}>
            <Link
              component={RouterLink}
              to={`/racks/details/${item.name}`}
              underline="hover"
              style={{ color: '#0066cc' }}
            >
              {item.name}
            </Link>{' '}
            on {item.deleteDate}
          </li>
        ))}
      </ul>
      {hasMore && (
        <button
          type="button"
          onClick={() => setShowAll(!showAll)}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            color: 'inherit',
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize: 'inherit',
            marginLeft: '20px'
          }}
        >
          {showAll ? 'Show less' : `Show ${items.length - max} more`}
        </button>
      )}
    </>
  );
}
